module.exports = __webpack_public_path__ + "static/media/2.5530c9aa.JPG";